module.exports = __webpack_public_path__ + "static/how-video-bg-min-fc57bcc942325802042465fb3d63cf64.png";